module.exports = __webpack_public_path__ + "img/teatext.e8e27854.png";